// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination[data-v-0fa27356]{display:flex;gap:6px;list-style:none;justify-self:center}button[data-v-0fa27356]{padding:6px 12px;border:1px solid #ccc;background:#fff;cursor:pointer}button.active[data-v-0fa27356]{background:#007bff;color:#fff}button[data-v-0fa27356]:disabled{opacity:.5;cursor:not-allowed}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
